export enum AddressTypeEnum {
  HOME = 'HOME',
  MAIL = 'MAIL',
  RESIDENTIAL = 'RESIDENTIAL',
  UNKNOWN = 'UNKNOWN',
  VENUE = 'VENUE',
  WORK = 'WORK',
}

export enum PlayingDoubleHandEnum {
  BH = 'BH',
  FB = 'FB',
  FH = 'FH',
  NO = 'NO',
  U = 'U',
}

export enum PlayingHandEnum {
  A = 'A',
  L = 'L',
  R = 'R',
  U = 'U',
}

export enum SexEnum {
  F = 'F',
  M = 'M',
}

export enum RatingTypeEnum {
  ITF = 'ITF',
  ITFDBL = 'ITFDBL',
}

export enum RatingSourceEnum {
  INIT = 'INIT',
  MATCHUPS = 'MATCHUPS',
  PSQ = 'PSQ',
  SEED = 'SEED',
  UNKNOWN = 'UNKNOWN',
}

export enum BallTypeEnum {
  HIGH_ALTITUDE = 'HIGH_ALTITUDE',
  STAGE1GREEN = 'STAGE1GREEN',
  STAGE2ORANGE = 'STAGE2ORANGE',
  STAGE3RED = 'STAGE3RED',
  T2STANDARD_PRESSURELESS = 'T2STANDARD_PRESSURELESS',
  T2STANDARD_PRESSURISED = 'T2STANDARD_PRESSURISED',
  TYPE1FAST = 'TYPE1FAST',
  TYPE3SLOW = 'TYPE3SLOW',
}

export enum CircuitEnum {
  J = 'J',
  M = 'M',
  S = 'S',
  U = 'U',
  W = 'W',
  WC = 'WC',
}

export enum SurfaceCategoryEnum {
  ARTIFICIAL = 'ARTIFICIAL',
  CLAY = 'CLAY',
  GRASS = 'GRASS',
  HARD = 'HARD',
  UNKNOWN = 'UNKNOWN',
}

export enum DrawStructureEnum {
  FI = 'FI',
  KO = 'KO',
  OT = 'OT',
  RR = 'RR',
}

export enum MatchUpGenderEnum {
  F = 'F',
  M = 'M',
  O = 'O',
  X = 'X',
}

export enum IndoorOutdoorEnum {
  INDOOR = 'INDOOR',
  OUTDOOR = 'OUTDOOR',
  UNKNOWN = 'UNKNOWN',
}

export enum PaceEnum {
  FAST = 'FAST',
  MEDIUM = 'MEDIUM',
  MEDIUM_FAST = 'MEDIUM_FAST',
  MEDIUM_SLOW = 'MEDIUM_SLOW',
  SLOW = 'SLOW',
}

export enum SideEnum {
  SIDE1 = 'SIDE1',
  SIDE2 = 'SIDE2',
}

export enum StateEnum {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
  UNKNOWN = 'UNKNOWN',
}

export enum MatchUpStatusEnum {
  ABANDONED = 'ABANDONED',
  BYE = 'BYE',
  COMPLETED = 'COMPLETED',
  DEAD_RUBBER = 'DEAD_RUBBER',
  DEFAULTED = 'DEFAULTED',
  DISQUALIFIED = 'DISQUALIFIED',
  RETIRED = 'RETIRED',
  SUSPENDED = 'SUSPENDED',
  WALKOVER = 'WALKOVER',
}

export enum SurfaceTypeEnum {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  J = 'J',
  K = 'K',
}

export enum StandardGradeEnum {
  CLB = 'CLB',
  DIS = 'DIS',
  INT = 'INT',
  LOC = 'LOC',
  NAT = 'NAT',
  REC = 'REC',
  REG = 'REG',
  ZON = 'ZON',
}

export enum MatchUpTypeEnum {
  DOUBLES = 'DOUBLES',
  SINGLES = 'SINGLES',
}

export enum WorldTennisNumberTypeEnum {
  DOUBLE = 'DOUBLE',
  SINGLE = 'SINGLE',
}

export enum FavouriteShotEnum {
  UNKNOWN = 'Unknown',
  BACKHAND = 'Backhand',
  DROPSHOT = 'DropShot',
  FOREHAND = 'Forehand',
  SERVE = 'Serve',
  SMASH = 'Smash',
  VOLLEY = 'Volley',
}

export enum MatchUpSubmissionStateEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export enum SignUpTypeEnum {
  FASTTRACK = 'fastTrack',
  WALKUP = 'walkUp',
}

export enum FeatureStatusEnum {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  FUTURE = 'FUTURE',
  UNKNOWN = 'UNKNOWN',
}

export enum WhereDidYouHearOptionEnum {
  NA = "NA",
  TENNIS_CLUB = "TENNIS_CLUB",
  TENNIS_TOURNAMENT = "TENNIS_TOURNAMENT",
  WORD_OF_MOUTH = "WORD_OF_MOUTH",
  SOCIAL_MEDIA = "SOCIAL_MEDIA",
  SEARCH_ENGINE = "SEARCH_ENGINE",
  BLOG_OR_PUBLICATION = "BLOG_OR_PUBLICATION",
  OTHER = "OTHER",
}